module.exports.AMAZON_MARKETPLACES_BY_COUNTRY_CODE = {
    US: ".com",
    CA: ".ca",
    UK : ".co.uk",
    DE : ".de",
    FR : ".fr",
    IT : ".it",
    ES : ".es",
    JP : ".co.jp",
    SG : ".sg",
    AE : ".ae",
    BR : ".com.br",
    AU : ".com.au",
    IN : ".in",
    NL : ".nl",
    SA : ".sa",
    TR : ".com.tr",
    SE : ".se",
    PL : ".pl"
}